import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { LEZForm, LEZFormData } from "src/forms/LEZForm";
import { useLEZCreateMutation } from "src/hooks";

interface Props {
  map: L.Map;
  onClose: () => void;
}

export function LEZCreatePage(props: Props) {
  const { t } = useTranslation();
  const { caseId = "", scenarioId = "" } = useParams<{
    caseId: string;
    scenarioId: string;
    lezId: string;
  }>();
  const navigate = useNavigate();
  const createMutation = useLEZCreateMutation(scenarioId);

  async function handleSave(values: LEZFormData) {
    const result = await createMutation.mutateAsync({
      ...values,
    });

    navigate(`/cases/${caseId}/scenarios/${scenarioId}/lezs/${result.id}`);
  }

  return render();

  function render() {
    return (
      <LEZForm
        map={props.map}
        title={t("label.addLowEmissionZone")}
        data={{
          name: "",
          polygon_frontendSrid: "",
          predefinedFleet: false,
        }}
        onClose={() => props.onClose()}
        onSubmit={handleSave}
        isLoading={createMutation.isLoading}
        errors={createMutation.error?.response?.data}
      />
    );
  }
}
